import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ActivityRow } from '@/lib/types';
import { fmtDateTime } from '@/lib/utils';
import { Card, ErrorNote, Loading, PageHeader } from '@/components/ui';

// Append-only record of every change: who, what, when, and the details.
export function ActivityPage() {
  const q = useQuery({ queryKey: ['activity'], queryFn: () => api.get<ActivityRow[]>('/api/activity?limit=500') });
  return (
    <>
      <PageHeader title="Activity log" subtitle="Every change made in BluePrint, newest first." />
      {q.isLoading ? <Loading /> : q.error ? <ErrorNote error={q.error} /> : (
        <Card className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left text-xs text-muted-fg uppercase"><tr className="border-b"><th className="px-4 py-2 font-medium">When</th><th className="px-4 py-2 font-medium">Who</th><th className="px-4 py-2 font-medium">What</th><th className="px-4 py-2 font-medium">Details</th></tr></thead>
            <tbody>
              {q.data!.map((r) => (
                <tr key={r.id} className="border-b align-top last:border-0">
                  <td className="px-4 py-2 whitespace-nowrap">{fmtDateTime(r.created_at)}</td>
                  <td className="px-4 py-2">{r.actor_name}</td>
                  <td className="px-4 py-2">{r.action.replaceAll('_', ' ')}</td>
                  <td className="max-w-md px-4 py-2 font-mono text-xs break-all text-muted-fg">{Object.keys(r.details).length ? JSON.stringify(r.details) : ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </>
  );
}
